'use client';

import * as React from 'react';
import { Analytics } from '@vercel/analytics/react';

export function VercelAnalyticsComponent(): React.JSX.Element {
  return <Analytics />;
}
